import { registerPlugin } from '@capacitor/core';
const SecureShare = registerPlugin('SecureShare', {
    web: () => import('./web').then(m => new m.SecureShareWeb()),
});
export * from './definitions';
export { SecureShare };
//# sourceMappingURL=index.js.map